var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"login-page-wrapper",class:_vm.adaptiveClass},[(_vm.isDesktop)?_c('LoginPreview',{attrs:{"image":_vm.loginGirl,"title-text":_vm.titleText,"description-text":_vm.descriptionText}}):_vm._e(),_c('LoginOptionsWrapper')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }